<template lang="pug">
.section.content
  div Welcome to {{ title }} {{ isOperator ? ', powered by Go:Do' : '' }}. Please, #[router-link(to="/log-in") log in] or #[router-link(to="/sign-up") sign up].
</template>

<script>
import Constants from '@/constants'

export default {
  computed: {
    isOperator () {
      return Constants.OPERATOR !== 3
    },
    title () {
      return Constants.TITLE
    }
  }
}
</script>
